import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';

import {AuthService} from './auth.service';
import {RoleService} from './role.service';

/**
 * Organization camera inventory and detail routes (/view-cameras, /edit-camera).
 * Allows platform Super User plus CoreOps Admin/Member; denies Sales Manager.
 * Does not open general CoreOps (vehicles, LPR, monitoring) to Super User.
 * Backend permissions remain the data-security boundary.
 */
@Injectable({
    providedIn: 'root',
})
export class CameraManagementAccessGuardService implements CanActivate {
    constructor(
        private auth: AuthService,
        private router: Router,
        private roleService: RoleService,
    ) {
    }

    canActivate(): boolean {
        if (!this.auth.isAuthenticated()) {
            void this.router.navigate(['/login']);
            return false;
        }

        const userInfo = this.auth.getCurrentUserInfo();
        const groups = userInfo?.role;

        if (this.roleService.canAccessCameraManagement(groups)) {
            return true;
        }

        this.router.navigate([this.roleService.getDefaultRoute(groups)]);
        return false;
    }
}
